import styled from 'styled-components';

export const DeckHead = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  & h2 {
    margin: 0 0 2px;
    font-size: 20px;
  }
`;

/** The deck's box. */
export const Box = styled.img`
  width: 72px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .4);
`;

export const Group = styled.section`
  margin-top: 14px;

  & h3 {
    margin: 0 0 8px;
    font-size: 12px;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: var(--muted);
  }
`;

export const CardGrid = styled.ul`
  --card-w: 84px;
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--card-w), 1fr));
  gap: 10px;
`;

export const CardSlot = styled.li`
  position: relative;
`;

/** How many copies: a pill on the card's corner. */
export const CardCount = styled.span`
  position: absolute;
  right: -4px;
  bottom: -4px;
  padding: 1px 7px;
  border-radius: 9px;
  background: #ffcb05;
  color: #1b1b1b;
  font-size: 12px;
  font-weight: 800;
  pointer-events: none;
`;
